import './vacancy-block.scss';
import Swiper from 'swiper/swiper-bundle';
export default () => {
	new Swiper( '.js-vacancy-swiper', {
		slidesPerView: 1,
		spaceBetween: 20,
		loop: false,
		navigation: {
			prevEl: '.vacancy-prev',
			nextEl: '.vacancy-next',
		},

		breakpoints: {
			640: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 50,
			},
		},
	} );
};
